<template>
  <div class="page-container">
    <div class="vote-bg-box">
      <img class="vote-bg" :src="require('../../assets/imgs/vote/vote_share_bg.png')" alt="">
    </div>
    <div class="content-box">
      <div class="title">{{voteArticle.voteTitle}}</div>
      
      <div v-if="viewpoint == 0" class="vote-btn-box">
        <img class="vote-btn vote-a" :src="require('../../assets/imgs/vote/big_vote_A.png')" alt="" @click="onClickVote(1)">
        <img class="vote-btn vote-b" :src="require('../../assets/imgs/vote/big_vote_B.png')" alt="" @click="onClickVote(2)">
      </div>

      <div v-if="viewpoint > 0" class="vote-result-box">
        <img class="vote-tip-icon" :src="require('../../assets/imgs/vote/vote_tip.png')" alt="">
        <vote-progress :percent="50" :encrypt="true"></vote-progress>
        <div class="vote-text" v-if="viewpoint == 1">你选择了”A：Agree”</div>
        <div class="vote-text" v-else-if="viewpoint == 2">你选择了B：Disagree”</div>
      </div>
      


      <div class="article-box">
        <img class="article-bg" :src="require('../../assets/imgs/vote/vote_article_bg.png')" alt="">
        <div class="article-content">
          <div class="article-tip">相关观点尽在文章中</div>
          <div class="article-title">{{voteArticle.title}}</div>
          <div class="article-source">#文章话题选自{{voteArticle.sourceCn}}</div>
        </div>
      </div>

      <div class="qrcode-box">
        <!-- <img class="qrcode-icon" :src="require('../../assets/imgs/vote/qrcode.jpeg')" alt=""> -->
        <img class="qrcode-icon" :src="qrCode" alt="二维码"/>
        <div class="qrcode-text">
          <div>关注蓝思原版分级阅读</div>
          <div>阅读文章查看投票结果</div>
        </div>
      </div>
    </div>

    <van-popup
      v-model="showPopup"
      position="top"
      custom-style="height: 20%;background-color:#00000000"
    >
      <div style="color: white;display:flex;flex-direction:column;" @click="showPopup=false">
        <div style="margin-right:30px;margin-top:20px;text-align:right">
          <img style="width:50px;" :src="require('@/assets/imgs/vote/top_right_guide.jpg')" />
        </div>
        <div style="text-align:center;font-size:18px;font-weight:bold;">
          点击上方“···”分享给好友或朋友圈
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
  import VoteProgress from "@/components/vote/VoteProgress";
  import { userVoteShareGetContent } from "@/api/vote"
  import { reportRecordVisitInfo } from "@/api/common"
  import wx from "weixin-js-sdk";

  export default {
    name: "VoteShare",
    data(){
      return {
        voteArticle: {
          title: "",
          sourceCn: "",
          voteTitle: ""
        },
        qrCode: '',
        viewpoint: 0,
        showPopup: false,
      }
    },
    components: {
      VoteProgress,
    },
    methods: {
      onClickVote(viewpoint) {
        this.viewpoint = viewpoint
      }
    },
    activated() {      
      if (!this.$route.query.bySelf) {
        reportRecordVisitInfo(this.$route.query.shareRecordId);
      }

      let params = {
        articleId: this.$route.query.articleId,
        shareRecordId: this.$route.query.shareRecordId
      }
      userVoteShareGetContent(params).then(result => {
        this.voteArticle = result.data.voteArticle
        this.qrCode = result.data.qrCode
        wx.ready(() => {
          // this.showPopup = this.$route.query.showGuide;
          wx.showMenuItems({
            menuList: [
              "menuItem:share:appMessage",
              "menuItem:share:timeline",
            ],
          });
          wx.updateAppMessageShareData({
            title: result.data.shareInfoVO.title, // 分享标题
            desc: result.data.shareInfoVO.desc, // 分享描述
            link: result.data.shareInfoVO.link, // 分享链接
            imgUrl: result.data.shareInfoVO.imgUrl, // 分享图标
          });
          wx.updateTimelineShareData({
            title: result.data.shareInfoVO.title, // 分享标题
            link: result.data.shareInfoVO.link, // 分享链接
            imgUrl: result.data.shareInfoVO.imgUrl, // 分享图标
          });
        });
      })
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    .page-container {
      width 100vw
      height 100vh
      background-color rgb(10, 42, 104)
      font-family serif,SimSun,STSong

      .vote-bg-box {
        width calc(100% + 1px)
        height 100%
        position absolute
        z-index 1
        overflow hidden
        
        .vote-bg {
          width 100%
          height 100%
        }
      }

      .content-box {
        position absolute
        z-index 10
        width 100%
        height 100%
        display flex
        flex-direction column
        align-items center

        .title {
          color #03ADFF
          font-size 22px
          font-weight bold
          text-align center
          padding 0 33px
          margin-top 82px
        }

        .vote-btn-box {
          display flex
          flex-direction row
          align-items center
          width 100%
          margin-top 50px
          margin-bottom 50px

          .vote-btn {
            width 50%
          }
        }

        .vote-result-box {
          width 100%;
          display flex
          flex-direction column
          align-items center

          .vote-tip-icon {
            margin-top 30px
            height 35px;
          }

          .vote-text {
            font-size 11px
            color #ffffff
            margin-top 17px
            margin-bottom 25px
          }
        }

        .article-box {
            width calc(100vw - 40px)
            color #16B2FB
            font-weight bold
            position relative

            .article-bg {
              width 100%
              height 130px
            }
            
            .article-content {
              width calc(100% - 25px)
              height calc(100% - 20px)
              padding 8px 0 0 13px
              position absolute
              top 0
              display flex
              flex-direction column
              justify-content center  
            }

            .article-tip {
              font-size 14px
            }

            .article-title {
              font-size 11px
              margin 9px 0
            }

            .article-source {
              font-size 11px
              text-align right 
            }
        }

        .qrcode-box {
          margin-top auto
          margin-bottom 25px
          display flex
          flex-direction row
          align-items center
          justify-content space-between

          .qrcode-icon {
            width 70px
            height 70px
          }

          .qrcode-text {
            margin-left 40px
            font-size 14px
            color #ffffff
            font-weight bold
            line-height 20px
          }
        }
       
      }
    }
</style>



// WEBPACK FOOTER //
// app/pages/share/VoteShare.vue